module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_13-893176133d83076c12dadba46e433a56.png";